import "./TheRigs.module.css";
import WildlingsWestHeader from "@/reusable_sections/Header";
import EngineeringTheExplorer from "./sections/EngineeringTheExplorer";
import TechnicalBuildGallery from "./sections/TechnicalBuildGallery";
import ExpeditionFooter from "@/reusable_sections/Footer";
export default function TheRigsPage() {
  return <div>
      <WildlingsWestHeader />
      <EngineeringTheExplorer />
      <TechnicalBuildGallery />
      <ExpeditionFooter />
    </div>;
}